import { Component, OnInit } from '@angular/core';
import { ContactService } from 'src/app/helper/contact/contact-helper.service';
import { Contact } from '../../models/contact/contact';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  model = new Contact; 
  submitted = false;
  error: {} | undefined;
  constructor(private contactService: ContactService,private titleService: Title) { }

onSubmit(form: any) {
  this.submitted = true;

  if (form.invalid) {
    return; // required errors will now show
  }

  // Submit to API only when valid
  this.contactService.contactForm(this.model).subscribe(
    data => this.model = data,
    error => this.error = error
  );
}

  resolved(captchaResponse: string) {
    console.log(`Resolved response token: ${captchaResponse}`);
  }


  ngOnInit(): void {
    this.titleService.setTitle('LaBurgers | Contact Us');
  }

}
